import { put } from './requests'

export function startDocumentCompletion ({ documentId, id }) {
  return put(`documents/${documentId}/completions/${id}/start`)
}

export function finishDocumentCompletion ({ documentId, id, date }) {
  return put(`documents/${documentId}/completions/${id}/finish?date=${date}`)
}
